import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=3b309fbc&scoped=true&"
import script from "./Jurisdiction.vue?vue&type=script&lang=js&"
export * from "./Jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=3b309fbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b309fbc",
  null
  
)

export default component.exports